<template>
  <bg-style v-if="enabled" v-imloading="loading" :is-disabled="$store.getters.isStandAloneMode" :bg="model.background" :mobile-bg="model.mobileBackground"
    :class="[`mobile-col-${model.cardSize}`, $store.getters.isMobile && 'is-mobile']" class="sign-activity-col"
    :style="getStyle">
    <module-block :bg="model.background" :mobile-bg="model.mobileBackground" :max-content-width="1280">
      <div v-if="model.titleVisible" class="sign-activity-col__title">
        <rich-text v-model="model.title" :editing="editing" :stroke.sync="model.titleStroke" class="w-full title"
          :disabled="!editing" theme="snow" />
      </div>
      <div v-if="model.subtitleVisible" class="sign-activity-col__subtitle mt-4">
        <rich-text v-model="model.subtitle" :editing="editing" :stroke.sync="model.subTitleStroke" :disabled="!editing"
          theme="snow" />
      </div>
      <div class="sign-activity-col__info flex justify-center text-16 gap-20 pt-10">
        <span>{{ $t('siteBuild.signWidget.tip1') }} {{ signData.has_sign_in_days }}</span>
        <span v-if="activityData?.activity_rule?.allow_remediation">{{ $t('siteBuild.signWidget.tip2') }} {{
          signData.remain_appending_days }}</span>
      </div>
      <div v-for="(item, index) in groupList" :key="`group-${index}`" class="sign-activity-col__list pt-6">
        <div v-for="(child, childIndex) in item" :key="`child-${childIndex}`">
          <bg-style v-if="child.day_no" :ref="`item-${childIndex}`" :radius="model.radius" class="item"
            :bg="model.signBackground" @click.native="handleShowDetail(child)">
            <img
              v-if="((editing && (index === 0 && childIndex === 0)) || child.is_sign_in) && model.signedMark?.backgroundImage"
              class="signed-icon" :src="model.signedMark.backgroundImage" alt="signed" />
            <bg-style class="thumb" :bg="model.logoBackground" :radius="[model.radius, model.radius, 0, 0]">
              <div class="day">{{ $t('siteBuild.signWidget.day', { day: child.day_no }) }}</div>
              <div class="logo-box">
                <img class="relative" :src="model.detailVisible ? (child.cover || child.thumb) : child.thumb" alt="icon" />
              </div>
              <div v-if="!model.detailVisible && child.gift_list && child.gift_list[0]" class="count">x{{ child.gift_list[0].num }}</div>
            </bg-style>
            <div class="info">
              <div v-if="model.detailVisible" class="details gap-4">
                <div v-for="(gift, gIndex) in child.gift_list" :key="gIndex"
                  class="pack flex items-center flex-shrink-0 font-bold">
                  <img class="icon" :src="gift.gift_goods_logo" alt="" />
                  <i class="el-icon-close font-bold" />
                  <span class="number">{{ gift.num }}</span>
                </div>
              </div>
              <bg-style v-if="(editing && (index === 0 && childIndex === 0)) || child.is_sign_in" class="handle" :bg="model.doneBackground"
                :radius="model.radius">
                <span class="relative">{{ $t('siteBuild.signWidget.signed') }}</span>
              </bg-style>
              <bg-style v-else-if="(editing && (index === 0 && childIndex === 1)) || child.is_appending" class="handle" :radius="model.radius"
                :bg="model.repairBackground" @click.native.stop="handleSignIn(child)">
                <span class="relative">{{ $t('siteBuild.signWidget.repair') }}</span>
              </bg-style>
              <bg-style v-else-if="(editing && (index === 0 && childIndex === 2)) || child.is_available_sign_in" class="handle"
                :radius="model.radius" :bg="model.buttonBackground" @click.native.stop="handleSignIn(child)">
                <span class="relative">{{ $t('siteBuild.signWidget.sign') }}</span>
              </bg-style>
              <bg-style v-else-if="child.is_expired" class="handle" :radius="model.radius" :bg="model.doneBackground">
                <span class="relative">{{ $t('siteBuild.expired') }}</span>
              </bg-style>
              <bg-style v-else class="handle unsign" :radius="model.radius" :bg="model.doneBackground">
                <span class="relative">{{ $t('siteBuild.signWidget.sign') }}</span>
                <img v-if="model.unSignMark.backgroundImageShow" :src="model.unSignMark.backgroundImage" alt />
              </bg-style>
            </div>
          </bg-style>
          <div v-else class="empty item" />
        </div>
      </div>
      <template v-if="signData.consecutive_list.length">
        <div class="consecutive-title mt-[20px]">
          <rich-text v-model="model.secondTitle" :editing="editing" class="relative" />
          <rich-text v-model="model.secondSubtitle" :editing="editing" class="mt-4 relative" />
        </div>
        <div v-for="(item, index) in csGroupList" :key="`cs-group-${index}`" class="sign-activity-col__list pt-6">
          <div v-for="(child, childIndex) in item" :key="`child-${childIndex}`">
            <bg-style v-if="child.sign_in_consecutive_days" :radius="model.radius"
              :bg="model.signBackground" class="item" @click.native="handleShowDetail(child)">
              <bg-style class="thumb" :bg="model.logoBackground" :radius="[model.radius, model.radius, 0, 0]">
                <div class="day">{{ $t('siteBuild.signWidget.day', { day: child.sign_in_consecutive_days }) }}</div>
                <div class="logo-box">
                  <img class="relative" :src="model.detailVisible ? (child.cover || child.thumb) : child.thumb" alt="icon" />
                </div>
                <div v-if="!model.detailVisible && child.gift_list && child.gift_list[0]" class="count">x{{ child.gift_list[0].num }}</div>
              </bg-style>
              <div class="info">
                <div v-if="model.detailVisible" class="details gap-4">
                  <div v-for="(gift, gIndex) in child.gift_list" :key="`gift-${gIndex}`"
                    class="pack flex items-center flex-shrink-0 font-bold">
                    <img class="icon" :src="gift.gift_goods_logo" alt="" />
                    <i class="el-icon-close font-bold" />
                    <span class="number">{{ gift.num }}</span>
                  </div>
                </div>
                <bg-style v-if="(editing && (index === 0 && childIndex === 0)) || child.is_sign_in" class="handle" :radius="model.radius"
                  :bg="model.doneBackground">
                  <span class="relative">{{ $t('siteBuild.activity.haveGet') }}</span>
                </bg-style>
                <bg-style v-else-if="(editing && (index === 0 && childIndex === 1)) || child.is_get" class="handle" :radius="model.radius"
                  :bg="model.buttonBackground" @click.native.stop="handleGetGift(child)">
                  <span class="relative">{{ $t('siteBuild.activity.get') }}</span>
                </bg-style>
                <bg-style v-else class="handle" :radius="model.radius" :bg="model.doneBackground">
                  <span class="relative">{{ $t('siteBuild.activity.get') }}</span>
                </bg-style>
              </div>
            </bg-style>
            <div v-else class="empty item" />
          </div>
        </div>
      </template>
    </module-block>
    <sign-info ref="info" :data="currentRow" :custom-style="getStyle" :is-mobile="isMobile" />
  </bg-style>
</template>

<script>
import { Empty } from 'element-ui'
import { sleep } from '~/utils'
import SignInfo from './info.vue'
import RichText from '~/components/richText/index.vue'
import ModuleBlock from '~/components/common/ModuleBlock.vue'
import logicMixin from './logicMixin'

export default {
  name: 'ColContent',
  components: {
    ModuleBlock,
    RichText,
    SignInfo,
    [Empty.name]: Empty
  },
  mixins: [logicMixin],
  watch: {
    async '$store.getters.isMobile'() {
      await sleep(500)
      this.initLayout()
    },
    cardSize() {
      this.initLayout()
    }
  }
}
</script>

<style lang="less">
.sign-activity-col {
  padding: 20px 0;
  --thumb-height: 140px;
  --day-height: 33px;
  --day-text-size: 15px;
  --count-text-size: 16px;

  &__title,
  &__subtitle {
    max-width: 1280px;
    margin: 0 auto;
    position: relative;
  }

  &__info {
    position: relative;
    color: var(--sign-text-color);
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    max-width: 1210px;
    position: relative;
    padding-bottom: 10px;

    .item {
      width: 160px;
      flex-shrink: 0;
      box-shadow: 2px 0 5px 0 rgba(0, 0, 0, 0.08);
      cursor: pointer;

      .signed-icon {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 200;
        border-radius: var(--sign-radius);
      }

      .thumb {
        width: 100%;
        height: var(--thumb-height);
        position: relative;
      }

      .thumb .day {
        width: 100%;
        text-align: center;
        font-size: var(--day-text-size);
        position: relative;
        line-height: var(--day-height);
        background: var(--sign-day-background);
        color: var(--sign-day-color);
        border-radius: var(--sign-radius) var(--sign-radius) 0 0;
      }

      .thumb .logo-box {
        height: calc(var(--thumb-height) - var(--day-height));
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
      }

      .thumb .logo-box img {
        max-width: 72px;
        max-height: 72px;
      }
      .thumb .count {
        position: absolute;
        right: 10px;
        bottom: 6px;
        min-height: 18px;
        line-height: 18px;
        color: var(--sign-text-color);
        font-size: var(--count-text-size);
        font-weight: bold;
      }

      .info {
        padding: 10px;
        position: relative;

        .details {
          display: flex;
          margin: 0 auto;
          overflow: auto;
          max-width: 100%;
          white-space: nowrap;
          color: var(--text-color);
          flex-wrap: nowrap;
          height: 40px;
          padding-bottom: 10px;
        }

        .details::-webkit-scrollbar {
          height: 0;
        }

        .details .pack {
          font-size: 14px;
          font-weight: bold;

          &:first-of-type {
            margin: 0 auto;
          }
        }

        .details .pack .icon {
          width: 30px;
          height: 30px;
        }

        .name {
          display: none;
        }

        .el-icon-close {
          color: var(--sign-text-color-50);
          font-size: 12px;
        }

        .number {
          color: var(--sign-text-color-50);
          font-size: 12px;
        }

        .handle {
          text-align: center;
          line-height: 40px;
          cursor: pointer;
          font-size: 16px;
          color: var(--sign-button-color);
          font-weight: bold;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            max-width: 80px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .handle.unsign {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .handle.unsign img {
          max-width: 20px;
          position: relative;
        }
      }
    }
  }

  &.is-mobile {
    padding: 10px;
    --count-text-size: 12px;
    .sign-activity-col__title,
    .sign-activity-col__subtitle {
      padding: 0 11px;
    }

    .sign-activity-col__list {
      padding: 0 5px;

      .item {
        .details {
          font-size: 12px;
          height: 30px;

          .icon {
            width: 20px;
            height: 20px;
          }

          .number {
            font-size: 12px;
          }
        }

        .thumb {
          .day {
            font-size: 12px;
          }

          .logo-box {
            img {
              max-width: 50px;
              max-height: 50px;
            }
          }
        }

        .info {
          padding: 5px;

          .handle {
            line-height: 24px;
            height: 24px;

            span {
              font-size: 12px;
            }

            &.unsign {
              img {
                max-width: 16px;
              }
            }
          }
        }
      }

      &.mobile-col-3 {
        .item {
          width: 100px;
        }
      }
    }
  }

  &.is-mobile.mobile-col-3 {
    --thumb-height: 84px;
    --day-height: 24px;

    .sign-activity-col__list {
      justify-content: space-between;
      gap: 0;
      .item {
        width: 100px;
      }
    }
  }

  &.is-mobile.mobile-col-4 {
    --thumb-height: 78px;
    --day-height: 24px;

    .sign-activity-col__list {
      justify-content: space-between;
      gap: 0;
      .item {
        width: 75px;

        .thumb {
          img {
            max-width: 40px;
            max-height: 40px;
          }
        }

        .info {
          padding: 5px;

          .details {
            padding-bottom: 5px;
          }
        }
      }
    }
  }
}
</style>
